import { X } from "lucide-react";
import { AIInstructionsCell } from "./AIInstructionsCell";
import { SectionSourcesSummary } from "./SectionSourcesSummary";
import type { GridReviewMap } from "@/lib/extractionReview";
import type { ReportJobStatus } from "@/types/models";
import type { Document } from "@/types/models";
import type { Section, SectionSources } from "./SortableRow";

interface SectionOutlinePanelProps {
  section: Section;
  sectionSources: SectionSources;
  documents: Document[];
  extractionPoints: { id: string; name: string; parent_id?: string | null }[];
  artifacts?: { uid: string; name: string; type: string }[];
  gridReview: GridReviewMap;
  onOpenSources: () => void;
  onSelectPrompt: () => void;
  onSaveInstruction?: (sectionId: string, value: string) => void;
  onGenerate: () => void;
  sectionStatus?: ReportJobStatus;
  queuePosition?: number;
  queueSize?: number;
  originalPriming?: string | null;
  hasContent: boolean;
  onClose: () => void;
}

export const SectionOutlinePanel = ({
  section,
  sectionSources,
  documents,
  extractionPoints,
  artifacts,
  gridReview,
  onOpenSources,
  onSelectPrompt,
  onSaveInstruction,
  onGenerate,
  sectionStatus,
  queuePosition,
  queueSize,
  originalPriming,
  hasContent,
  onClose,
}: SectionOutlinePanelProps) => {
  return (
    <div className="min-w-0 bg-[#F7F6EE] p-4 flex flex-col gap-4">
      <div className="flex items-start justify-between">
        <span className="font-semibold text-sm text-foreground">Sources</span>
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground shrink-0"
          title="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <SectionSourcesSummary
        documents={documents}
        extractionPoints={extractionPoints}
        artifacts={artifacts}
        gridReview={gridReview}
        sectionSources={sectionSources}
        onOpenSources={onOpenSources}
      />

      <div className="flex flex-col gap-1.5">
        <span className="font-semibold text-sm text-foreground">AI Instructions</span>
        <AIInstructionsCell
          section={section}
          onSelectPrompt={onSelectPrompt}
          onGenerate={onGenerate}
          onSaveInstruction={onSaveInstruction}
          sectionStatus={sectionStatus}
          queuePosition={queuePosition}
          queueSize={queueSize}
          originalPriming={originalPriming}
          hasContent={hasContent}
        />
      </div>
    </div>
  );
};
